import Vue from 'vue'

Vue.filter('datefrText', function (value) {
  if (!value) return ''
  const options = { weekday: 'long', month: 'short', day: 'numeric' }
  value = new Date(value)
  return value.toLocaleDateString('fr-FR', options)
})

Vue.filter('datefrTextLong', function (value) {
  if (!value) return ''
  const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }
  value = new Date(value)
  return value.toLocaleDateString('fr-FR', options)
})

Vue.filter('datefrShort', function (value) {
  if (!value) return ''
  value = new Date(value)
  return value.toLocaleDateString()
})

Vue.filter('datefrShorter', function (value) {
  if (!value) return ''
  const options = { day: 'numeric', month: 'numeric' }
  value = new Date(value)
  return value.toLocaleDateString('fr-FR', options)
})

Vue.filter('dateWithTimefr', function (value) {
  if (!value) return ''
  const options = { day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' }
  value = new Date(value)
  return value.toLocaleDateString('fr-FR', options)
})

Vue.filter('dateOnlyTimefr', function (value) {
  if (!value) return ''
  const options = { hour: 'numeric', minute: 'numeric' }
  value = new Date(value)
  return value.toLocaleTimeString('fr-FR', options)
})

Vue.filter('frTime', function (value) {
  if (!value) return ''
  const date = new Date(value)
  return `${date.getHours()}h${String(date.getMinutes()).padStart(2, '0')}`
})

Vue.filter('slice', function (value, maxLength) {
  if (value.length < maxLength) return value
  return value.slice(0, maxLength - 4) + ' ...'
})

Vue.filter('capitalize', function (value) {
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
})

Vue.filter('kb', function (value) {
  return Math.round(parseInt(value) / 10000)
})
